import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LayoutDashboard, Users, MessagesSquare, BellRing, ArrowLeft, KeyRound } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { AuroraBackground } from "@/components/AuroraBackground";
import { Logo } from "@/components/Brand";
import { Footer } from "@/components/Footer";
import { AdminDashboard } from "@/components/admin/AdminDashboard";
import { AdminUsers } from "@/components/admin/AdminUsers";
import { AdminMessages, AdminPush } from "@/components/admin/AdminComms";
import { AdminKeys } from "@/components/admin/AdminKeys";

const TABS = [
  { id: "cruscotto", label: "Cruscotto", Icon: LayoutDashboard },
  { id: "utenti", label: "Utenti", Icon: Users },
  { id: "messaggi", label: "Messaggi", Icon: MessagesSquare },
  { id: "push", label: "Notifiche push", Icon: BellRing },
  { id: "chiavi", label: "Chiavi API", Icon: KeyRound, su: true },
];

export default function Admin() {
  const { user } = useAuth();
  const [tab, setTab] = useState("cruscotto");
  const [chatUser, setChatUser] = useState(null);
  const [pushUser, setPushUser] = useState(null);
  const [users, setUsers] = useState([]);
  useEffect(() => { if (tab === "push") api.get("/admin/users").then((r) => setUsers(r.data)); }, [tab]);

  return (
    <div className="min-h-screen flex flex-col text-slate-200">
      <AuroraBackground />
      <header className="sticky top-0 z-40 backdrop-blur-2xl bg-[#030712]/85 border-b border-amber-400/20">
        <div className="px-4 sm:px-6 py-3 flex items-center gap-3">
          <Logo to="/app" small />
          <span className="hud-tag !text-amber-300 hidden sm:inline">Pannello Super Admin</span>
          <Link to="/app" className="ml-auto btn-ghost-hud rounded-full px-3 py-1.5 text-xs flex items-center gap-1.5" data-testid="btn-back-app"><ArrowLeft size={14} /> App</Link>
        </div>
        <nav className="flex gap-1 px-3 sm:px-6 pb-2 overflow-x-auto no-scrollbar">
          {TABS.filter((t) => !t.su || user.role === "superadmin").map(({ id, label, Icon }) => (
            <button key={id} onClick={() => setTab(id)} data-testid={`admin-tab-${id}`}
              className={`shrink-0 flex items-center gap-1.5 px-3.5 py-2 rounded-lg text-sm transition-colors ${tab === id ? "bg-amber-400/15 text-amber-100 border border-amber-400/40" : "text-slate-400 hover:text-white border border-transparent"}`}>
              <Icon size={15} /> {label}
            </button>
          ))}
        </nav>
      </header>
      <main className="flex-1 px-4 sm:px-6 py-6 max-w-[1500px] w-full mx-auto">
        <h1 className="font-heading text-3xl sm:text-4xl font-bold text-white mb-5 glow-title">{TABS.find((t) => t.id === tab).label}</h1>
        {tab === "cruscotto" && <AdminDashboard />}
        {tab === "utenti" && <AdminUsers me={user} onMessage={(u) => { setChatUser(u); setTab("messaggi"); }} onPush={(u) => { setPushUser(u); setTab("push"); }} />}
        {tab === "messaggi" && <AdminMessages selected={chatUser} setSelected={setChatUser} />}
        {tab === "push" && <AdminPush target={pushUser} setTarget={setPushUser} users={users} />}
        {tab === "chiavi" && user.role === "superadmin" && <AdminKeys />}
      </main>
      <Footer />
    </div>
  );
}
